<script setup lang="ts">
// Older links (e.g. undo hints from MCP) point at /operations/:id — same page as approvals.
definePage({
  redirect: (to) => ({ path: `/approvals/${(to.params as { id: string }).id}` }),
});
</script>

<template>
  <div />
</template>
